// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"245":"7e7c15f157f91e84a671","453":"4d7f7a58530ec6c75b0d"}[chunkId] + ".js";
};